<template>
  <div class="company-tenancy-record-wrapper">
    <ul
      id="company-tenancy-record-accordion"
      class="accordion accordion-customize"
      data-accordion
      data-deep-link="true"
      data-allow-all-closed="true"
      data-mutli-expand="true"
      data-update-history="true"
      data-deep-link-smudge="500"
    >
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title"><span>{{ $t('company.titles.tenancyRecord') }}</span></a>
        <div
          class="accordion-content"
          data-tab-content
        >
          <table>
            <thead>
              <th>{{ $t('company.tenancyRecord.recordId') }}</th>
              <th>{{ $t('company.contactTable.roleType') }}</th>
              <th>{{ $t('company.tenancyRecord.premises') }}</th>
              <th>{{ $t('company.tenancyRecord.tradeName') }}</th>
              <th>{{ $t('company.tenancyRecord.mainContact') }}</th>
              <th>{{ $t('company.tenancyRecord.contactPhone') }}</th>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in tenancies"
                :key="index"
              >
                <td>{{ item.id }}</td>
                <td>{{ calcRoleType (item) }}</td>
                <td>
                  <a
                    class="link"
                    @click="navTo('ccdTenancyView', { id: item.id })"
                  >{{ item.premises || '--' }}</a>
                </td>
                <td>{{ item.tradeName || '--' }}</td>
                <td>{{ getMainContactName(item) }}</td>
                <td>{{ getMainContactPhone(item) }}</td>
              </tr>
            </tbody>
          </table>
          <button
            v-show="allowCreateTenancy&&showCreateTenancy"
            class="btn btn--orange"
            :disabled="!currentCompany.active"
            @click="navTo('ccdTenancyCreate', {}, { companyId: currentCompany.id })"
          >
            {{ $t('company.tenancyRecord.createTenancyRecord') }}
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapGetters } from 'vuex'
import formFullnameMixin from '@/pages/formFullnameMixin'
import { aclHelper, ccdPermsTypes } from '@/utils/aclHelper'
import navigation from '@/utils/navigation'
import { calcContactRoleType } from '../tenancy/utils'

export default {
  name: 'CompanyTenancyRecord',
  mixins: [formFullnameMixin],
  props: {
    allowCreate: Boolean,
    showCreateTenancy: {
      default: true,
      type: Boolean,
    },
    tenancies: Array,
    contactId: {
      type: String,
      default: '',
    },
  },
  setup () {
    return {
      calcRoleType: calcContactRoleType,
    }
  },
  computed: {
    ...mapGetters('ccd', ['currentCompany']),
    ...mapGetters('user', ['acTenancyIsOffice', 'acTenancyIsRetail']),
    allowCreateTenancy () {
      return (this.acTenancyIsOffice || this.acTenancyIsRetail) && this.allowCreate && aclHelper.getAccess(ccdPermsTypes.tenancy.create)
    },
  },
  mounted () {
    if (!this.companyTenancyRecordAccordion) {
      this.companyTenancyRecordAccordion = new Foundation.Accordion($('#company-tenancy-record-accordion'))
    }
  },
  destroyed () {
    if (this.companyTenancyRecordAccordion) {
      this.companyTenancyRecordAccordion.destroy()
    }
  },
  methods: {
    navTo (name, params, query) {
      navigation.toPage(name, params, query)
    },
    getMainContactName (item) {
      return this.displayI18nFullName(
        lodash.get(item, ['accounts', 0, 'TenancyAccount', 'contactFirstName']),
        lodash.get(item, ['accounts', 0, 'TenancyAccount', 'contactLastName']),
      )
    },
    getMainContactPhone (item) {
      return deep(item, ['accounts', 0, 'TenancyAccount', 'phone']) || this.$t('emptyValue')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/tender/view';
@import '~styles/accordion';
@import '~styles/table';

.link {
  text-decoration: underline;
  color: #0C3A58;
}
</style>
